/* eslint-disable */
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ConfirmComponent } from './components/confirm/confirm.component';
import { LoginErrorComponent } from './components/login-error/login-error.component';
import { StatusReviewComponent } from './components/status-review/status-review.component';

const routes: Routes = [
  { path: '', component: ConfirmComponent },
  { path: 'login-error', component: LoginErrorComponent },
  { path: 'status-review', component: StatusReviewComponent},
  {
    path: 'send-confirmation',
    loadChildren: () =>
      import('src/app/components/send-confirmation/send-confirmation.module').then((m) => m.SendconfirmationHomeModule),
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { initialNavigation: 'enabledBlocking', scrollPositionRestoration: 'top' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
